import React,{useState,useEffect, useCallback, useRef} from 'react';
import { useSelector } from 'react-redux';
import './AddressInput.css'
import AccordionFieldset from '../AccordionFieldset'
import isEqual from 'lodash/isEqual';
import config from '../../config/config';
import { showError, showWarning } from '../../helpers/notifications';
const AddressField = ({
    name,
    sx = {},
    transform = 'none',
    placeholder = '',
    showRequiredIndicator = false,
    label = '',
    value='',
    onChange = {},
    inline = false, 
    disabled = false,    // by default dont disable the field
    className=''
})=> {
    const updateAddressField = (e) => {
        onChange(e)
    }
     return (
        <div style={{display: inline?'inline-block':'block',float: inline?'left':'none', textAlign: 'left', marginBottom: '10px', ...sx}} className={className} >
            <div style={{display: 'inline-block', ...sx}} className={className} >
                <label style={{display: 'inline'}} className={className} >
                <span  className={`${disabled?'disabled':''} ${className}`}>{label}</span>
                {showRequiredIndicator && <span className="required-indicator">*</span>}
                {!showRequiredIndicator && <span className="required-indicator">&nbsp;</span>}
                <input
                    value = {value}
                    id={name}
                    type='text'
                    style={{...(sx.input??{}), textTransform: transform }}
                    placeholder={placeholder}
                    onChange={(e) => updateAddressField(e)}
                    disabled={disabled}
                    className={className}
                />
                </label>
            </div>
        </div>
    )
}

const AddressBlock = ({
    address,
    addresstype = 'Main Office Address',
    maxaddrs = 1,
    label = 'Address',
    name,
    options,
    register,
    errors,
    validation,
    align = 'left',
    sx = {},
    index=1,
    value = [],
    onChange = {},
    onDelete = {},
}) => {
    const [addrfields, setAddrFields] = useState({})
    const [searchresults,setSearchResults] = useState([])
    const [showresults, setShowResults] = useState(false)
    const previousData = useRef();
    const prevaddrFields = useRef();

    // Get auth token from Redux, fallback to external API token
    const authToken = useSelector((state) => state.auth.token);
    const token = authToken || config.EXTERNAL_API_TOKEN;

    useEffect(() => {
        
            const handler = setTimeout(() => {
                if(!isEqual(addrfields, prevaddrFields.current)) {
                    prevaddrFields.current = addrfields
                    onChange(addrfields);
                }
            }, 50);

            return () => clearTimeout(handler); // Cancel previous timeout if still typing

    }, [addrfields, onChange]);

    useEffect(()=> {
        if(!isEqual(value,previousData.current)) {
            setAddrFields({...value, index: 0})
            previousData.current = {...value, index: 0}
        }
    },[value,setAddrFields])
    


    const updateAddressField = useCallback((field, valuein) => {
        setAddrFields((cur) => ({...cur, ...[field].value}) )
    },[setAddrFields])

    const findAddress = async () => {
        try {
            const postcode = addrfields?.postcode
            if((postcode??"").trim() === "" ) {
                showWarning("You Must Enter a Postcode before Searching for an Address")
                return;
            }
            const url = `${config.API_BASE_URL}${config.endpoints.address.find}/${postcode}`
            const ret = await fetch(url,{
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
            if(ret.status === 200 && ret.statusText === "OK") {
                const data = await ret.json()
                setSearchResults(data.data);
                setShowResults(true);
            }
        }catch(err) {
            showError(`There was an error searching for the Addresses at ${addrfields?.postcode}. Please Try Again`)
        }

    }

    const selectSearch = async (e) => {
        setShowResults(false)
        try {
            const url = `${config.API_BASE_URL}${config.endpoints.address.get}/${e.target.value}`
            const ret = await fetch(url,{
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
            if(ret.status === 200 && ret.statusText === "OK") {
                const data = await ret.json()
                if(data.status) {
                    setSearchResults([])
                    setAddrFields((cur) => { 
                        const newval = {...cur, 
                            ...{
                            addr1: data.data.line_1,
                            addr2: data.data.line_2,
                            addr3: data.data.line_3,
                            town: data.data.town_or_city,
                            county: data.data.county,
                            postcode: data.data.postcode,
                            country: data.data.country,
                            datevacated: '',
                            useregistered: false,
                            name: 'registered_address'
                            }
                        }
                        return newval 
                    })
                }

            }else {
                showError("There was an Error retrieving the Selected Address data. Please Try Again ")
                setShowResults(true)
            }
        }catch(err) {
            showError("There was an Error retrieving the Selected Address data. Please Try Again ")
            setShowResults(true) 
        }

    }
    const formatTitle = () => {
        if(name === 'registered_address') 
            return label
        return `${label} ${(addrfields?.name??"") > ""?"- " + addrfields?.name:''}`
    }
    const removeAddress= (index)=> {
        if(window.confirm("Are you sure you wish to Delete this Address? Press Ok to Confirm"))
            onDelete(index)
    }

    return (
    <AccordionFieldset title={formatTitle()} className='smallcss' collapsed={false}>
        {(parseInt(addrfields.index??0) > 0) &&
            <i className="fa fa-trash-o deleteaddr" onClick={() => removeAddress(addrfields?.index)} ></i>
        }
        <div style={{display: 'block', paddingTop: '10px'}} >
        {(addrfields.name??"") !== 'registered_address' &&
                <label style={{textAlign: 'left', fontSize: '0.8rem', verticalAlign: 'middle', margin: '0 auto 0 a'}}>
                    <input type='checkbox' value={addrfields.useregistered??""} onChange ={(e) => updateAddressField('useregistered', e.target.checked)}  />&nbsp;Use Registered Address
                </label>
        }

            <AddressField 
                value = {name==='registered_address'?'Company Registered Address':(addrfields.name??"")}
                onChange ={(e) => updateAddressField('name', e.target.value)} 
                placeholder={addresstype}
                label='Address Type / Name'
                showRequiredIndicator={true}
                name='addressname' 
                sx={{
                    width: '100%', 
                    label: {width: '40%', marginRight: '10px'}, 
                    input: {width: '60%'}
                }} 
            />
            <AddressField className='addr1' value = {addrfields.addr1??""} onChange ={(e) => updateAddressField('addr1', e.target.value)} placeholder='Building Street' name={`addr1_${index}`}  disabled={addrfields.useregistered}  showRequiredIndicator={true}  />
            <AddressField className='addr2' value = {addrfields.addr2??""}  onChange ={(e) => updateAddressField('addr2', e.target.value)}  name={`addr2_${index}`}  disabled={addrfields.useregistered} />
            <AddressField className='addr3' value = {addrfields.addr3??""}  onChange ={(e) => updateAddressField('addr3', e.target.value)}  name={`addr3_${index}`}   disabled={addrfields.useregistered} />
            <AddressField className='town'  value = {addrfields.town??""}  onChange ={(e) => updateAddressField('town', e.target.value)}  placeholder='Town' name={`town_${index}`}   disabled={addrfields.useregistered} />
            <AddressField className='county' value = {addrfields.county??""}  onChange ={(e) => updateAddressField('county', e.target.value)}  placeholder='County' name={`county_${index}`}  disabled={addrfields.useregistered} />
            <div style={{display: 'inline-block', float: 'left'}} >
                <AddressField showRequiredIndicator={true} value = {addrfields.postcode??""}  onChange ={(e) => updateAddressField('postcode', e.target.value)}  placeholder='Postcode' name={`postcode_${index}`} sx={{input: {width: '12rem'} }} transform='uppercase' inline={true}  disabled={addrfields.useregistered} />
                <input type='button' className='addsrchbtn' value='Find Address' onClick={findAddress} />  
            </div>
            <div style={{display: 'inline-block',  width: '100%', textAlign: 'left', marginTop: '10px'}} >
                <label style={{width: '100%', textAlign: 'left', fonrSize: '0.8rem!important'}}>If Address is Vacated, Please give date: 
                    <input type='date' value={addrfields.datevacated} onChange ={(e) => updateAddressField('datevacated', e.target.value)}  placeholder='Date Vacated' name={`datvacated_${index}`} style={{marginLeft: '10px', width: '115px'}} />
                </label>
            </div>
            {showresults &&             
                <div className='addresssearch' >
                    Postcode {addrfields.postcode??""} Returned {searchresults.length} addresses. Select the correct address below.<br/>
                    <select name='selectsearch' onChange={selectSearch} >
                        <option value="" >Not Listed Below - Enter Manually</option>
                        {searchresults.map((item,index) => (
                            <option key={`srchpc_${index}`} value={item.id}>{item.address}</option>
                        ))}
                    </select>
                </div>
            }  
        </div>
    </AccordionFieldset>
    )
}

const AddressInput = ({
    label = 'Address',
    addresstype = 'Main Office Address',
    maxaddrs = 1,   // Unless specified then Stick to just 1 Address
    name,
    options,
    register,
    errors,
    validation,
    align = 'left',
    sx = {},
    showRequiredIndicator = false,
    index = 1,
    value,
    registered_address,
    onChange
}) => {
    const [addressloaded, setAddressLoaded] = useState(false)
    //const [addresses, setAddresses ] = useState([])
    const [addressdata, setAddressData ] = useState([])
    const previousData = useRef();
    
    useEffect(() => {
        if (!addressloaded) {
          const incoming = Array.isArray(value) ? value : [];
      
          setAddressData(
            incoming.length > 0
              ? incoming.map((addr, i) => ({ ...addr, index: i }))
              : [{ name: '', addr1: '', addr2: '', addr3: '', town: '', county: '', postcode: '', country: '', datevacated: '',useregistered: false, index: 0 }]
          );
          previousData.current = incoming
          setAddressLoaded(true);
        }
    }, [value, addressloaded]);

    useEffect(()=> {
        if (!isEqual(previousData.current, addressdata)) {
            previousData.current = addressdata;
            setAddressData((cur) => (cur??[]).map(item=> {
            let addr = item
            if((item?.useregistered??false) )
                addr = registered_address
            return addr
            }))
        }
    },[addressdata, registered_address])

    useEffect(() => {
        const isEmpty = (addressdata ?? []).every(addr =>
          Object.keys(addr).filter(k => k !== "index").every(key => !addr[key])
        );
      
        if (!isEmpty) {
            if (!isEqual(previousData.current, addressdata)) {
                previousData.current = addressdata;
                onChange(addressdata);
              }
        }
      }, [addressdata, onChange]);

    const addAddress = () => {
        setAddressData((curdata) => [...curdata, {name:'',addr1:'',addr2:'',addr3:'',town:'',county:'',postcode:'', datevacated: '', useregistered: '', index:curdata.length }])
    }

    const updateAddress = (index, updated) => {
        setAddressData((current) => { 
            (current??[]).map((item,i) => {
                if(i===index)
                    return updated
                return item
            })
        })
    }

    const deleteAddress = (i) => {
        setAddressData((curr) => curr.filter(item => item.index !== i))
    }

    if((addressdata??[]).length > 0 && (addressdata??[]).length > 0 )
        return (
            <>
            {(addressdata??[]).map((address,i) => { 
                //const addrdata = (addressdata??[{}])[parseInt((index??0))]
                return (
                <AddressBlock
                    key={`${name}_${i}`}
                    addresstype={addresstype}
                    maxaddrs={maxaddrs}
                    label={label}
                    name={name}
                    options={options}
                    register={register}
                    errors={errors}
                    validation={validation}
                    align={align}
                    sx={sx}
                    index={i+1}
                    value={address}
                    onChange={(updated) => updateAddress(i, updated)}
                    onDelete={() => deleteAddress(i)}
                />
            )})
            }
            {parseInt(maxaddrs??1) > index && <input type='button' value='Add Another Address' className='addbtn' onClick={addAddress} /> }

            </>
        )
}


export default AddressInput;